<script setup>
import { useI18n } from 'vue-i18n';
import { XCard, XLink, XIcon } from '@clicksign/excalibur';

const { t } = useI18n();

defineProps({
  showResult: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'var(--color-brand-primary-400)',
  },
  containerWidth: {
    type: String,
    default: '448px',
  },
});
</script>

<template>
  <main :class="$style.documentValidator">
    <XCard
      :class="$style.card"
      padding="var(--space-regular) var(--space-medium) var(--space-large)"
      outlined
      :style="`border-color: ${color};`"
    >
      <XLink
        v-if="!showResult"
        :class="$style.homeLink"
        no-padding
        to="/"
      >
        {{ t('general.action.returnToHome') }}
      </XLink>
      <section
        v-if="!showResult"
        :class="$style.container"
      >
        <div
          :class="$style.header"
          :style="`width: ${containerWidth};`"
        >
          <XIcon
            v-if="icon"
            :icon="icon"
            size="2x"
            :style="`color: ${color};`"
          />

          <h1 :class="$style.title">
            <slot name="title" />
          </h1>

          <div :class="$style.description">
            <slot name="description" />
          </div>
        </div>

        <div :class="$style.actionContainer">
          <slot name="action" />
        </div>
      </section>

      <template v-else>
        <slot name="result" />
      </template>
    </XCard>
  </main>
</template>

<style lang="scss" module>
.documentValidator {
  display: flex;
  justify-content: center;

  .card {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 960px;
    margin-top: var(--space-large-x);
  }

  .homeLink {
    align-self: flex-start;
  }

  .container {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  .header {
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 100%;
  }

  .title {
    margin: var(--space-small-xx) 0px;
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-bold);
    color: var(--color-neutral-1000);
  }

  .description {
    margin-bottom: var(--space-small-x);
    text-align: center;

    > * {
      font-size: var(--font-size-regular);
      color: var(--color-neutral-700);
    }
  }

  .actionContainer {
    width: 100%;
    text-align: center;
  }
}
</style>
